module.exports = __webpack_public_path__ + "images/commercial-floorplan1-0f93841daf6439f4d14f993420b90656.jpg";